import React from 'react';
import Add from './addVehicle';

const Edit = ({ data, handleClick,getData}) => {
  return <Add data={data} handleClick={handleClick} getData={getData}/>;
};

export default Edit;
